import PropTypes from 'prop-types';
import MobileIslandActionIsland from './MobileIslandActionIsland';
import WorkbenchIconAction from '../common/WorkbenchIconAction';

/** 左岛：页面按钮（Home 由 key==='home' 触发 onHomeClick） */
const MobileIslandDockLeadIsland = ({ items, onHomeClick }) => {
	if (!items?.length) {
		return null;
	}

	const pageItem = items.find((item) => item.key === 'page');
	const ariaLabel = pageItem?.label ?? (items.length === 1 ? items[0].label : '页面按钮');

	return (
		<MobileIslandActionIsland single={items.length === 1} ariaLabel={ariaLabel}>
			{items.map((item) => (
				<WorkbenchIconAction
					key={item.key}
					className={item.key === 'home' ? 'app-mobile-action-island__home' : 'app-mobile-action-island__link'}
					icon={item.icon}
					iconComponent={item.iconComponent}
					onClick={item.key === 'home' ? onHomeClick : item.onClick}
					active={item.key === 'page'}
					title={item.label}
					ariaLabel={item.label}
					ariaCurrent={item.key === 'page' ? 'page' : undefined}
				/>
			))}
		</MobileIslandActionIsland>
	);
};

MobileIslandDockLeadIsland.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
			iconComponent: PropTypes.elementType,
			label: PropTypes.string.isRequired,
			onClick: PropTypes.func,
		}),
	),
	onHomeClick: PropTypes.func.isRequired,
};

export default MobileIslandDockLeadIsland;
